var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"kp-footer",attrs:{"app":"","inset":""}},[(_vm.loading)?_c('KpIcon',{attrs:{"icon-cls":"load ic-spin","color":"grey"}}):_vm._e(),_c('v-spacer'),_vm._v(" Minasa - V. "+_vm._s(_vm.version)+" | © "+_vm._s(_vm.copyYear)+" "),_c('a',{attrs:{"href":"https://kadenpartner.ch"}},[_vm._v("kaden und partner ag")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }